(function () {
  'use strict';

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function selectedVariantData(control) {
    if (!control) return { price: 0, compare: 0, available: false, image: '' };
    var source = control.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
    return {
      price: Number(source.dataset.price || 0),
      compare: Number(source.dataset.compare || 0),
      available: source.dataset.available === 'true',
      image: source.dataset.image || ''
    };
  }

  function initScratch(section) {
    section.querySelectorAll('[data-nv-gift]').forEach(function (gift) {
      if (gift.dataset.scratchReady === 'true') return;
      gift.dataset.scratchReady = 'true';
      var canvas = gift.querySelector('[data-nv-scratch]');
      if (!canvas) return;
      var context = canvas.getContext('2d', { willReadFrequently: true });
      var drawing = false;
      var checks = 0;

      function sizeCanvas() {
        if (gift.classList.contains('is-revealed')) return;
        var bounds = gift.getBoundingClientRect();
        var ratio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.max(1, Math.round(bounds.width * ratio));
        canvas.height = Math.max(1, Math.round(bounds.height * ratio));
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        var gradient = context.createRadialGradient(bounds.width / 2, bounds.height / 2, 5, bounds.width / 2, bounds.height / 2, bounds.width * .7);
        gradient.addColorStop(0, '#7ba877');
        gradient.addColorStop(1, '#c9c9c9');
        context.globalCompositeOperation = 'source-over';
        context.fillStyle = gradient;
        context.fillRect(0, 0, bounds.width, bounds.height);
        context.fillStyle = 'rgba(255,255,255,.84)';
        context.font = '800 10px sans-serif';
        context.textAlign = 'center';
        context.fillText('FREE GIFT', bounds.width / 2, bounds.height / 2 - 9);
      }

      function point(event) {
        var bounds = canvas.getBoundingClientRect();
        return { x: event.clientX - bounds.left, y: event.clientY - bounds.top };
      }

      function scratch(event) {
        if (!drawing) return;
        event.preventDefault();
        var current = point(event);
        context.globalCompositeOperation = 'destination-out';
        context.beginPath();
        context.arc(current.x, current.y, 21, 0, Math.PI * 2);
        context.fill();
        checks += 1;
        if (checks % 7 !== 0) return;
        var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        var transparent = 0;
        var sampled = 0;
        for (var index = 3; index < pixels.length; index += 64) {
          sampled += 1;
          if (pixels[index] < 60) transparent += 1;
        }
        if (sampled && transparent / sampled > .4) {
          drawing = false;
          gift.classList.add('is-revealed');
        }
      }

      canvas.addEventListener('pointerdown', function (event) {
        drawing = true;
        canvas.setPointerCapture(event.pointerId);
        scratch(event);
      });
      canvas.addEventListener('pointermove', scratch);
      canvas.addEventListener('pointerup', function () { drawing = false; });
      canvas.addEventListener('pointercancel', function () { drawing = false; });
      sizeCanvas();
      if ('ResizeObserver' in window) new ResizeObserver(sizeCanvas).observe(gift);
    });
  }

  function initQuestions(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-nv-qa-tab]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-nv-qa-card]'));
    var track = section.querySelector('[data-nv-qa-track]');
    if (!tabs.length || !track || track.dataset.qaReady === 'true') return;
    track.dataset.qaReady = 'true';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var category = tab.dataset.nvQaTab;
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        cards.forEach(function (card) { card.hidden = category !== 'all' && card.dataset.category !== category; });
        track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });

  }

  function initGallery(section) {
    var mainImage = section.querySelector('[data-nv-main-image]');
    var dialog = section.querySelector('[data-nv-media-dialog]');
    var dialogImage = section.querySelector('[data-nv-dialog-image]');
    section.querySelectorAll('[data-nv-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.querySelectorAll('[data-nv-thumb]').forEach(function (item) { item.classList.toggle('is-active', item === thumb); });
        if (mainImage && thumb.dataset.image) mainImage.src = thumb.dataset.image;
        if (dialogImage && thumb.dataset.image) dialogImage.src = thumb.dataset.image;
      });
    });
    var open = section.querySelector('[data-nv-open-media]');
    var close = section.querySelector('[data-nv-close-media]');
    if (open && dialog && typeof dialog.showModal === 'function') {
      open.addEventListener('click', function () {
        if (dialogImage && mainImage) dialogImage.src = mainImage.currentSrc || mainImage.src;
        dialog.showModal();
      });
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    }
  }

  function initProduct(section) {
    if (section.dataset.productReady === 'true') return;
    section.dataset.productReady = 'true';
    var currency = section.dataset.currency || 'USD';
    var cartUrl = section.dataset.cartUrl || '/cart';
    var rootUrl = section.dataset.rootUrl || '/';
    var form = section.querySelector('.nv-product-form');
    var variantControl = section.querySelector('[data-nv-variant]');
    var quantityInput = section.querySelector('[data-nv-quantity]');
    var bundles = Array.prototype.slice.call(section.querySelectorAll('[data-nv-bundle]'));
    var submit = section.querySelector('[data-nv-submit]');
    var submitLabel = section.querySelector('[data-nv-submit-label]');
    var submitPrice = section.querySelector('[data-nv-submit-price]');
    var status = section.querySelector('[data-nv-form-status]');
    var currentPrice = section.querySelector('[data-nv-current-price]');
    var comparePrice = section.querySelector('[data-nv-compare-price]');
    var discountBadge = section.querySelector('[data-nv-discount-badge]');
    var originalLabel = submitLabel ? submitLabel.textContent : '';
    var soldOutLabel = section.dataset.soldOutText || 'SOLD OUT';

    function selectedBundle() {
      return bundles.find(function (bundle) { return bundle.querySelector('input').checked; }) || bundles[0];
    }

    function render() {
      var variant = selectedVariantData(variantControl);
      if (currentPrice) currentPrice.textContent = formatMoney(variant.price, currency);
      var hasCompare = variant.compare > variant.price;
      if (comparePrice) {
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(variant.compare, currency) : '';
      }
      if (discountBadge) {
        discountBadge.hidden = !hasCompare;
        discountBadge.textContent = hasCompare ? '-' + Math.round((variant.compare - variant.price) * 100 / variant.compare) + '%' : '';
      }
      if (variant.image) {
        var mainImage = section.querySelector('[data-nv-main-image]');
        var dialogImage = section.querySelector('[data-nv-dialog-image]');
        if (mainImage) mainImage.src = variant.image;
        if (dialogImage) dialogImage.src = variant.image;
      }

      bundles.forEach(function (bundle) {
        var quantity = Number(bundle.dataset.quantity || 1);
        var discount = Number(bundle.dataset.discount || 0);
        var compare = variant.price * quantity;
        var total = Math.round(compare * (100 - discount) / 100);
        var priceNode = bundle.querySelector('[data-nv-bundle-price]');
        var compareNode = bundle.querySelector('[data-nv-bundle-compare]');
        if (priceNode) priceNode.textContent = formatMoney(total, currency);
        if (compareNode) {
          compareNode.hidden = discount === 0;
          compareNode.textContent = discount ? formatMoney(compare, currency) : '';
        }
      });

      var bundle = selectedBundle();
      var selectedQuantity = bundle ? Number(bundle.dataset.quantity || 1) : 1;
      var selectedDiscount = bundle ? Number(bundle.dataset.discount || 0) : 0;
      var selectedTotal = Math.round(variant.price * selectedQuantity * (100 - selectedDiscount) / 100);
      if (quantityInput) quantityInput.value = String(selectedQuantity);
      if (submitPrice) submitPrice.textContent = formatMoney(selectedTotal, currency);
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? originalLabel : soldOutLabel;
    }

    bundles.forEach(function (bundle) {
      var radio = bundle.querySelector('input');
      radio.addEventListener('change', function () {
        bundles.forEach(function (item) { item.classList.toggle('is-selected', item === bundle); });
        render();
      });
    });
    if (variantControl && variantControl.tagName === 'SELECT') variantControl.addEventListener('change', render);

    if (form && submit) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submit.disabled) return;
        submit.disabled = true;
        if (submitLabel) submitLabel.textContent = 'ADDING…';
        if (status) status.textContent = '';
        var endpoint = rootUrl.replace(/\/?$/, '/') + 'cart/add.js';
        fetch(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || 'Unable to add this item.');
            return payload;
          });
        }).then(function () {
          var bundle = selectedBundle();
          var code = bundle ? bundle.dataset.discountCode : '';
          if (code) {
            window.location.href = rootUrl.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
          } else if (section.dataset.redirectToCart === 'true') {
            window.location.href = cartUrl;
          } else {
            if (status) status.textContent = 'Added to cart.';
            return fetch(rootUrl.replace(/\/?$/, '/') + 'cart.js').then(function (response) { return response.json(); }).then(function (cart) {
              document.querySelectorAll('.nv-header__cart-count').forEach(function (node) { node.textContent = cart.item_count; });
            });
          }
        }).catch(function (error) {
          if (status) status.textContent = error.message;
        }).finally(function () {
          var variant = selectedVariantData(variantControl);
          submit.disabled = !variant.available;
          if (submitLabel) submitLabel.textContent = variant.available ? originalLabel : soldOutLabel;
        });
      });
    }

    var shippingDate = section.querySelector('[data-nv-ship-date]');
    var shippingBar = shippingDate ? shippingDate.closest('[data-shipping-days]') : null;
    if (shippingDate && shippingBar) {
      var date = new Date();
      date.setDate(date.getDate() + Number(shippingBar.dataset.shippingDays || 0));
      shippingDate.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'long', month: 'short', day: 'numeric' }).format(date);
    }
    initGallery(section);
    initScratch(section);
    initQuestions(section);
    render();
  }

  function initHelpful(root) {
    root.querySelectorAll('[data-nv-helpful]').forEach(function (button) {
      if (button.dataset.helpfulReady === 'true') return;
      button.dataset.helpfulReady = 'true';
      button.addEventListener('click', function () {
        var liked = button.classList.toggle('is-liked');
        var initial = Number(button.dataset.count || 0);
        var count = button.querySelector('span');
        if (count) count.textContent = String(initial + (liked ? 1 : 0));
        button.setAttribute('aria-pressed', liked ? 'true' : 'false');
      });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-nv-product]').forEach(initProduct);
    initHelpful(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
